export const appEvents = "iRL2le";
export default {appEvents};